var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrigger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trigger"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.99997 14.9994H5.89997C5.49997 14.9994 5.20414 14.8202 5.01247 14.4619C4.8208 14.1035 4.84164 13.7577 5.07497 13.4244L12.55 2.67435C12.7166 2.44102 12.9333 2.27852 13.2 2.18685C13.4666 2.09519 13.7416 2.09935 14.025 2.19935C14.3083 2.29935 14.5166 2.47435 14.65 2.72435C14.7833 2.97435 14.8333 3.24102 14.8 3.52435L14 9.99935H17.875C18.3083 9.99935 18.6125 10.191 18.7875 10.5744C18.9625 10.9577 18.9083 11.316 18.625 11.6494L10.4 21.4994C10.2166 21.716 9.99164 21.8577 9.72497 21.9244C9.4583 21.991 9.19997 21.966 8.94997 21.8494C8.69997 21.7327 8.50414 21.5535 8.36247 21.3119C8.2208 21.0702 8.16664 20.8077 8.19997 20.5244L8.99997 14.9994Z",
    fill: "#4C4948"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrigger);
export default __webpack_public_path__ + "static/media/trigger.1df4982c74029f08409736877e8f5961.svg";
export { ForwardRef as ReactComponent };